// Profile route (specs/profile-page) — the self-profile, pushed from the header/menu avatar.
// Full-screen takeover (tab bar hidden via HIDE_TAB_BAR_ROUTES); back returns to the prior screen.
import { ProfileScreen } from '../../src/profile/components/ProfileScreen';

export default function ProfileRoute() {
  return <ProfileScreen />;
}
